import { CommonConfigType, commonConfig as commonDefaultConfig, Markets } from 'scbk-services';

export const CommonConfig: CommonConfigType = {
    ...commonDefaultConfig,
    language: {
        value: 'ko',
        markets: {
            [Markets.KR]: {
                value: 'ko',
            },
        },
    },
    landingRoute: {
        value: '/',
    },

    loginRoute: {
        value: '/login',
    },
};
